import {
  getState,
  updateForm,
  onlyIfAutoForm,
  formSelector,
  useSelector,
} from '../../../../store.js'
import {isPresent} from '../../../../common/utils.js'
import {NEW_ID} from '../../../../common/constants/SettingsPanels.js'
import {MIVA} from '../../../../common/constants/CartVendorOptions.js'
import {cartSelector} from '../../../../data/carts.js'
import TextInput from '../../Common/TextInput.js'
import FormList from '../../Common/FormList.js'
import FormListItem from '../../Common/FormListItem.js'
import VendorForm from './VendorForm.js'
import NameInput from '../NameInput.js'
import AuthorizeHelper from '../AuthorizeHelper.js'
import {
  baseEditCartParamsSelector,
  baseNewCartParamsSelector,
  baseSaveParamsSelector,
  cartFormErrorsSelector,
} from '../salesChannelsSelectors.js'
import PackingListSelect from '../PackingListSelect.js'
import RevisionConfig from '../RevisionConfig.js'
import SyncConfig from '../SyncConfig.js'

export function setUpCartForm({cartID, formName}) {
  return {
    formName,
    initialForm: {
      ...initialFormSelector(getState(), {cartID}),
      errorsSelector,
      saveParamsSelector,
      serverParamErrorsSelector,
    },
  }
}

export function errorsSelector(state, {formName}) {
  const form = formSelector(state, {formName})
  const errors = {}

  if (!form) {
    return errors
  }

  if (!isPresent(form.api_token)) {
    errors.api_token = 'Access Token is required'
    errors.preventSave = true
  }

  if (!isPresent(form.signature_key)) {
    errors.signature_key = 'Signature Key is required'
    errors.preventSave = true
  }

  if (!isPresent(form.store_code)) {
    errors.store_code = 'Store Code is required'
    errors.preventSave = true
  }

  if (!isPresent(form.store_url)) {
    errors.store_url = 'Endpoint URL is required'
    errors.preventSave = true
  }

  return errors
}

export function initialFormSelector(state, {cartID}) {
  if (cartID === NEW_ID) {
    return {
      ...baseNewCartParamsSelector(state, {vendor: MIVA}),
      api_token: '',
      signature_key: '',
      store_code: '',
      store_url: '',
    }
  }

  const cart = cartSelector(getState(), {cartID})

  return {
    ...baseEditCartParamsSelector(getState(), {cartID}),
    api_token: cart.vendor_config.api_token,
    signature_key: cart.vendor_config.signature_key,
    store_code: cart.vendor_config.store_code,
    store_url: cart.vendor_config.store_url,
  }
}

export function serverParamErrorsSelector(state, {formName}) {
  const {serverError} = formSelector(state, {formName})
  const errors = {}

  if (serverError.param === 'api_token') {
    errors.api_token = serverError.error_message
  } else if (serverError.param === 'signature_key') {
    errors.signature_key = serverError.error_message
  } else if (serverError.param === 'store_code') {
    errors.store_code = serverError.error_message
  } else if (serverError.param === 'store_url') {
    errors.store_url = serverError.error_message
  }

  return errors
}

export function saveParamsSelector(state, {formName}) {
  const form = formSelector(state, {formName})

  return {
    ...baseSaveParamsSelector(state, {formName}),
    api_token: form.api_token,
    signature_key: form.signature_key,
    store_code: form.store_code,
    store_url: form.store_url,
  }
}

function Miva({form, formName}) {
  const isNew = form.id === NEW_ID
  const errors = useSelector((state) =>
    cartFormErrorsSelector(state, {formName}),
  )

  return (
    <VendorForm>
      <div className="medium-6 columns">
        <FormList>
          {!isNew && <NameInput formName={formName} />}
          <FormListItem>
            <TextInput
              name="store_url"
              label="Endpoint URL"
              required
              value={form.store_url || ''}
              errorMessage={form.hasChanged_store_url && errors.store_url}
              onChange={(event) =>
                updateForm(formName, {
                  store_url: event.target.value,
                  hasChanged_store_url: true,
                })
              }
            />
          </FormListItem>
          <FormListItem>
            <TextInput
              name="api_token"
              label="Access Token"
              required
              value={form.api_token || ''}
              errorMessage={form.hasChanged_api_token && errors.api_token}
              onChange={(event) =>
                updateForm(formName, {
                  api_token: event.target.value,
                  hasChanged_api_token: true,
                })
              }
            />
          </FormListItem>
          <FormListItem>
            <TextInput
              name="signature_key"
              label="Signature Key"
              required
              value={form.signature_key || ''}
              errorMessage={
                form.hasChanged_signature_key && errors.signature_key
              }
              onChange={(event) =>
                updateForm(formName, {
                  signature_key: event.target.value,
                  hasChanged_signature_key: true,
                })
              }
            />
          </FormListItem>
          <FormListItem>
            <TextInput
              name="store_code"
              label="Store Code"
              required
              value={form.store_code || ''}
              errorMessage={form.hasChanged_store_code && errors.store_code}
              onChange={(event) =>
                updateForm(formName, {
                  store_code: event.target.value,
                  hasChanged_store_code: true,
                })
              }
            />
          </FormListItem>
          {!isNew && (
            <>
              <PackingListSelect className="divider--top" formName={formName} />
              <RevisionConfig className="divider--top" formName={formName} />
              <SyncConfig className="divider--top" formName={formName} />
            </>
          )}
        </FormList>
      </div>
      <div className="medium-5 columns">
        <AuthorizeHelper
          vendorName="Miva"
          href="https://support.ordoro.com/miva-api-setup/"
        />
      </div>
    </VendorForm>
  )
}

export default onlyIfAutoForm(Miva, setUpCartForm)
